const moneyIsLessThan = {
  computesRequired: true,
  getMessage: (field, params) => {
    return 'O campo ' + field + ' deve maior que ' + params
  },
  validate (value, { min }) {
    const formatedValue = value.replace('R$ ', '').replace(',', '.')
    const formatedMin = min.replace('R$ ', '').replace(',', '.')
    return +formatedValue < formatedMin
  }
}

export default moneyIsLessThan



// WEBPACK FOOTER //
// ./src/customValidators/moneyIsLessThan.js